import { ENV } from './env'

export const carto = layer => `https://{a-d}.basemaps.cartocdn.com/${layer}/{z}/{x}/{y}.png?key=${ENV.CARTO_KEY}`

export const esri = layer => `https://server.arcgisonline.com/ArcGIS/rest/services/${layer}/MapServer/tile/{z}/{y}/{x}`

export const google = layer => `https://mt0.google.com/vt/lyrs=${layer}&hl=en&x={x}&y={y}&z={z}`

export const thunderforest = layer => `https://{a-c}.tile.thunderforest.com/${layer}/{z}/{x}/{y}.png?apikey=${ENV.THUNDERFOREST_KEY}`

export const tomtom = layer => `https://{a-d}.api.tomtom.com/map/1/tile/${layer}/{z}/{x}/{y}.png?key=${ENV.TOMTOM_KEY}`

export const mapbox = style => `https://api.mapbox.com/styles/v1/mapbox/${style}/tiles/512/{z}/{x}/{y}?access_token=${ENV.MAPBOX_TOKEN}`
export const mapboxTwoX = style => `https://api.mapbox.com/styles/v1/mapbox/${style}/tiles/512/{z}/{x}/{y}@2x?access_token=${ENV.MAPBOX_TOKEN}`
export const mapboxStyle = style => `https://api.mapbox.com/styles/v1/mapbox/${style}?access_token=${ENV.MAPBOX_TOKEN}`

export const locationiq = layer => `https://tiles.locationiq.com/v3/${layer}/r/{z}/{x}/{y}.png?key=${ENV.LOCATIONIQ_KEY}`

export const mapy = layer => `https://api.mapy.cz/v1/maptiles/${layer}/tiles.json?lang=nl&apikey=${ENV.MAPY_KEY}`

export const kartogiraffe = (type = '') => `https://tiles.kartogiraffe.de/tiles/tile.php?zoom={z}&x={x}&y={y}${type}`

export const jawg = (layer = '') => `https://tile.jawg.io/${layer ? `${layer}/` : ''}{z}/{x}/{y}.png?api-key=${ENV.JAWG_KEY}`

export const lvnl = (includeVfrAirspacesInUrl = false) => `https://geoservices.lvnl.nl/arcgis/rest/services/${includeVfrAirspacesInUrl ? 'VFRchart/Airspaces/MapServer' : ''}`

export const openaip = `https://api.tiles.openaip.net/api/data/openaip/{z}/{x}/{y}.png?apiKey=${ENV.OPENAIP_KEY}`
